import { AlertCircle, Monitor, Calendar, Loader2 } from 'lucide-react';
import { Tabs } from '~/shared/components/tabs/Tabs';
import { QueryParamTabs } from '~/shared/components/tabs/QueryParamTabs';
import { ScheduleReport } from './report/ScheduleReport';
import { NeedsAssigned } from './needsassigned/NeedsAssigned';
import { EpisodeTotals } from './episode-totals/EpisodeTotals';
import { WeeklyTotals } from './weekly-totals/WeeklyTotals';
import { PageLayout } from '~/shared/PageLayout';
import { ErrorBanner } from '~/shared/ErrorBanner';
import { useQuery } from '@tanstack/react-query';
import { getLegacyScheduleReportProcessingOptions } from '@generated';

const tabs = [
	{ id: 'schedule', label: 'Schedule', icon: Calendar },
	{ id: 'needsassigned', label: 'Needs Assigned', icon: AlertCircle },
	{ id: 'weeklytotals', label: 'Weekly Totals', icon: Monitor },
	{ id: 'episodetotals', label: 'Episode Totals', icon: Monitor }
];

export function LegacySchedulingPage() {
	const { data: scheduleProcessing } = useQuery(getLegacyScheduleReportProcessingOptions());

	//Show error if schedule report processing or downloading failedFv
	const scheduleReportError = scheduleProcessing?.downloadError || scheduleProcessing?.processingError;
	//Schedule report is loading, display banner
	const showScheduleLoading = scheduleProcessing?.downloading || scheduleProcessing?.processing;

	return (
		<PageLayout pageHeader={{ title: 'Schedule', description: 'Manage scheduling, assignments, and capacity', TitleIcon: Calendar }}>
			{scheduleReportError && <ErrorBanner message={scheduleReportError} />}
			{showScheduleLoading && (
				<div className="mb-6 flex items-start gap-3 rounded-xl border border-blue-200 bg-blue-50 p-4">
					<Loader2 className="mt-0.5 size-5 shrink-0 animate-spin text-blue-600" />
					<div>
						<h3 className="mb-1 text-sm font-semibold text-blue-900">
							{scheduleProcessing?.downloading ? 'Downloading schedule report…' : 'Processing schedule report…'}
						</h3>
						<p className="text-sm text-blue-700">This may take a few minutes. The latest data will appear when it&apos;s ready.</p>
					</div>
				</div>
			)}
			<QueryParamTabs defaultTab={tabs[0].id} paramName="selectedTab" clearRemainingParams>
				<Tabs.TabList aria-label="Visit Sections">
					{tabs.map(tab => (
						<Tabs.Tab key={tab.id} id={tab.id}>
							<div className="flex items-center gap-2">
								<tab.icon size={18} />
								{tab.label}
							</div>
						</Tabs.Tab>
					))}
				</Tabs.TabList>
				<Tabs.TabPanel id="schedule" className="p-4">
					<ScheduleReport />
				</Tabs.TabPanel>
				<Tabs.TabPanel id="needsassigned" className="p-4">
					<NeedsAssigned />
				</Tabs.TabPanel>
				<Tabs.TabPanel id="weeklytotals" className="p-4">
					<WeeklyTotals />
				</Tabs.TabPanel>
				<Tabs.TabPanel id="episodetotals" className="p-4">
					<EpisodeTotals />
				</Tabs.TabPanel>
			</QueryParamTabs>
		</PageLayout>
	);
}
